import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";

import Gitub from "@iconscout/react-unicons/icons/uil-github";
import Linkdin from "@iconscout/react-unicons/icons/uil-linkedin";
import {DiGoogleCloudPlatform} from  "react-icons/di";



const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />

      <div className="f-content">
        <span>faizullah9181@gmail.com</span>
        <span>9318480098</span>
        <div className="f-icons">
       
        <a href="https://github.com/Faizullah9181"> <Gitub color="white" size={"3rem"} /></a> 
         <a href="https://linkedin.com/in/faizullah-0597271b9"> <Linkdin color="white" size={"3rem"} /></a>
         <a href="https://www.qwiklabs.com/public_profiles/1f90fe1b-abb8-4c16-b06e-749e6fe32fdb"><DiGoogleCloudPlatform color="white" size={"3.1rem"} /></a> 
       
     
        </div>
      </div>


    </div>
  );
};

export default Footer;
